/**
 * Business Plan API service
 */

import apiClient from './api';

export interface BusinessPlanQuestion {
  question: string;
  question_number: number;
  total_questions: number;
  all_complete?: boolean;
}

export interface BusinessPlanContent {
  content: string;
  generated_at: string;
  status: string;
}

export const businessPlanService = {
  async startQA(sessionId: string): Promise<any> {
    const response = await apiClient.post(`/api/sessions/${sessionId}/business-plan/start-qa`);
    return response.data;
  },

  async getCurrentQuestion(sessionId: string): Promise<BusinessPlanQuestion> {
    const response = await apiClient.get(`/api/sessions/${sessionId}/business-plan/qa/current`);
    return response.data;
  },

  async submitAnswer(sessionId: string, answer: string): Promise<any> {
    const response = await apiClient.post(`/api/sessions/${sessionId}/business-plan/qa`, { answer });
    return response.data;
  },

  async generate(sessionId: string): Promise<any> {
    const response = await apiClient.post(`/api/sessions/${sessionId}/business-plan/generate`);
    return response.data;
  },

  async getBusinessPlan(sessionId: string): Promise<BusinessPlanContent> {
    const response = await apiClient.get(`/api/sessions/${sessionId}/business-plan`);
    return response.data;
  },

  getDownloadUrl(sessionId: string): string {
    return `${apiClient.defaults.baseURL}/api/sessions/${sessionId}/business-plan/download`;
  },
};

export default businessPlanService;
